module.exports = __webpack_public_path__ + "img/bingobonanza.92b89d6c.png";